// Link Handler

window.SiteReady(($) => {
  console.log('Init: Link Handler');

  $.expr[':'].external = function(a) {
    let check = a.href.replace('http://', 'https://');

    return (!check.match(/^mailto\:/) && !check.match(/^tel\:/) && !check.match(/^fax\:/))
      && (check.indexOf(parentSiteURL) >= 0 && check.indexOf(currentSiteURL) < 0);
  };

  function openParentLink(e) {
    e.preventDefault();
    e.stopPropagation();

    targetURL = $(this).attr('href');

    if (targetURL.indexOf('#ad-open-') > -1) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      window.open(targetURL);
    }
  }

  let currentSiteID = THEME_OPTIONS.current_site;
  let currentSiteURL = THEME_OPTIONS.current_site_url;
  let parentSiteURL = THEME_OPTIONS.parent_site_url;

  if (currentSiteID !== 1) {
    $('a:external').attr('data-parent-link', 'true');

    $(document).on('click', '[data-parent-link="true"]', openParentLink);
  }

  $(document).on('click', 'a[href*="#ad-open-"]', (e) => {
    // e.preventDefault();
    // e.stopPropagation();

    // console.log('ad-click');
  });

});